import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { message, Modal } from "antd";
import Button from "../components/shared/button";
import ReminderDeleted from "./reminderDeleted";
import { useTranslation } from "react-i18next";
import { deleteCase } from "../APIs/caseApis";
import { AppContext } from "../context/AppContext";

const DelTableRowModal = ({ isdelModalOpen, setIsdelModalOpen }) => {
  const { t } = useTranslation();
  const [isDeletedModalOpen, setIsDeletedModalOpen] = useState(false);
  const{setNewCaseAdded}=useContext(AppContext);
  const handleOk = () => {
    setIsdelModalOpen(null);
  };

  const handleCancel = () => {
    setIsdelModalOpen(null);
  };

  const handleDelete = () => {

    setNewCaseAdded(true);

    deleteCase(isdelModalOpen)
      .then((res) => {
        setNewCaseAdded(false);
        message.success("Case Deleted Successfully");
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
        message.error("Error Deleting Case");
        setNewCaseAdded(false);
      });
    setIsdelModalOpen(null);
    setIsDeletedModalOpen(true);

    setTimeout(() => {
      setIsDeletedModalOpen(false);
    }, 1000);
  };

  return (
    <>
      <Modal
        open={isdelModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content flex flex-col items-center p-[34px] gap-[24px]">
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            {t("adminDashboard.deleteModal.title")}
          </h5>
          <div className="flex gap-[8px]">
            <Button
              text={t("adminDashboard.deleteModal.yes")}
              className="button btn-blue-border rounded-[39px] large"
              height={45}
              width={142}
              onClick={handleDelete}
            />
            <Button
              text={t("adminDashboard.deleteModal.no")}
              className="button btn-blue !rounded-[39px] large"
              height={45}
              width={142}
              onClick={handleCancel}
            />
          </div>
        </div>
      </Modal>

      <ReminderDeleted
        isDeletedModalOpen={isDeletedModalOpen}
        setIsDeletedModalOpen={setIsDeletedModalOpen}
      />
    </>
  );
};

export default DelTableRowModal;
